import { Box } from '@rebass/emotion';
import styled from '@emotion/styled';
import theme from '@app/styles/theme';
import { rem } from '@app/styles/theme/layout';

export const ContentWrapper = styled(Box)`
  max-width: ${theme.layout.containerMaxWidth};
  margin: 0 auto;
`;

export const ContentBlock = styled(Box)`
  line-height: 1.8rem;
`;

export const LayoutTitle = styled.h1`
  font-size: ${rem(40)};
  line-height: 1.2;
`;

export const LayoutSubtitle = styled.h3`
  font-size: ${rem(24)};
  font-family: ${theme.fonts.fontSemi};
  font-weight: 400;
  letter-spacing: ${rem(0.01)};
  color: ${theme.colors.gray};
  margin: ${rem(10)} 0;
`;

export const QuantityLabel = styled.label`
  font-size: ${rem(16)};
  display: block;
`;

export const FindDealerButton = styled.a`
  font-size: ${rem(16)};
  margin-top: ${rem(20)};
  height: ${rem(38)};
  background: ${theme.colors.white};
  border: ${rem(2)} solid ${theme.colors.darkGray};
  color: ${theme.colors.darkGray};
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  &:hover {
    opacity: 0.8;
  }
`;
